import { useState, useEffect, useCallback } from "react";

const useLocationByIP = (isEnabled: boolean) => {
  const [location, setLocation] = useState<{
    latitude: number | null;
    longitude: number | null;
  }>({ latitude: null, longitude: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchLocationByIP = useCallback(async () => {
    try {
      if (!isEnabled) return;
      setLoading(true);
      setError(null);
      const response = await fetch("https://get.geojs.io/v1/ip/geo.json");
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const data = await response.json();
      setLocation({
        latitude: parseFloat(data.latitude),
        longitude: parseFloat(data.longitude),
      });
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Failed to fetch location");
      }
    } finally {
      setLoading(false);
    }
  }, [isEnabled]);

  useEffect(() => {
    fetchLocationByIP();
  }, [fetchLocationByIP]);

  return { location, loading, error, refetch: fetchLocationByIP };
};

export default useLocationByIP;
